import { Input } from "@legacy/Input";
import { Popover } from "@mui/material";
import { styled } from "@mui/material/styles";

export const DateRangeInput = styled(Input)({
  "& input": {
    cursor: "pointer",
  },
});

const PREFIX = "Popover-date-range";
export const classes = {
  root: `${PREFIX}-root`,
};

export const StyledPopover = styled(Popover)(() => ({
  [`&.${classes.root}`]: {
    "& .MuiPopover-paper": {
      padding: "0px",
    },
  },
}));
